import { Typography } from "@timeedit/ui-components";
import { translations } from "@timeedit/registration-shared";
import "./conflict.scss";
import ScheduleConflict from "@timeedit/ui-components/icons/ScheduleConflict";

type ConflictNotificationProps = {
  useText?: boolean;
  className?: string;
  text?: string;
  ids?: number[];
  /** Id of the text, so a control can reference it */
  id?: string;
};

export function ConflictNotification({
  useText,
  text,
  ids,
  id,
}: ConflictNotificationProps): React.JSX.Element {
  return (
    <div data-reservation-ids={ids}>
      {useText ? (
        <ScheduleConflict aria-hidden className="conflict-notification__svg" />
      ) : (
        <ScheduleConflict
          alt={translations.scheduleConflict}
          className="conflict-notification__svg"
        />
      )}
      {useText && (
        <Typography.Text id={id} className="conflict-notification__text">
          {translations.conflict} {text}
        </Typography.Text>
      )}
    </div>
  );
}
